import z from "zod";

export const StatusTierSchema = z.object({
  name: z.string().min(1),
  percentage: z.number().min(0),
});

export interface StatusTier {
  name: string;
  percentage: number;
}
